import { z } from "zod";
import {} from "./domain.js";
export const updateContestSchema = z
    .object({
    name: z.string().min(1).max(200).optional(),
    durationSeconds: z.number().int().positive().max(24 * 3600).optional(),
    freezeBeforeEndSeconds: z.number().int().nonnegative().optional(),
    penaltyMinutes: z.number().int().nonnegative().max(1000).optional(),
    /** Exigido para alterar freeze/penalty depois que o contest comecou. */
    confirm: z.boolean().optional(),
})
    .refine((v) => Object.keys(v).some((k) => k !== "confirm"), {
    message: "Informe ao menos um campo para alterar",
});
//# sourceMappingURL=contest.js.map